var path = 'app/core/components/dropdown/dropdownSelectOption.html';
var html = "<div class=\"dropdown__menu-item\"\n    data-hook-id={{'l_item'}}\n    ng-class=\"{'active': isActive()}\"\n    ng-disabled=\"disabled\"\n    ng-click=\"select($event)\"\n    ng-transclude>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;